import { defineComponent as i, computed as l } from "vue";
import s from "./td-longtail-vue-components262.js";
import c from "./td-longtail-vue-components3.js";
const m = /* @__PURE__ */ i({
  __name: "energy-label-icon",
  props: {
    energyClass: null,
    reverse: { type: Boolean, default: !1 },
    tag: { default: "button" },
    type: { default: "button" }
  },
  emits: ["click"],
  setup(n, { emit: e }) {
    const t = n, o = l(() => `Energieeffizienz ${t.energyClass}`);
    return { __sfc: !0, props: t, emit: e, title: o, emitClick: (r) => {
      e("click", r);
    }, Icon: s, LinkButton: c };
  }
});
export {
  m as default
};
